import { Layer } from './layer';
import TileLayer from 'ol/layer/Tile';

export class VoidLayer extends Layer {  
    constructor(id: string, label: string, type: string) {
        super(id, label, type);
    }
    toOlLayer() {
        let tileLayer = new TileLayer({ source: null });
        tileLayer.set('customId', this.id)
        return tileLayer;
    }
}